import ReactFlow, {
  Background,
  BackgroundVariant,
  ConnectionMode,
  MarkerType,
  ReactFlowProvider,
  addEdge,
  getNodesBounds,
  updateEdge,
  useEdgesState,
  useNodesState,
} from "reactflow";
import ToolBarMaps from "../../../../../componentes/easyMaps/toolbarMaps";
import ZoomFlow from "../../../../../componentes/easyMaps/ZoomFlow";
import NodeMenu from "../../../../../componentes/easyMaps/nodeMenu";
import { Box, lighten, Stack, useTheme } from "@mui/material";
import ElementNode from "../../../../../componentes/easyMaps/elementNode";
import PositionableEdge from "../../../../../componentes/easyMaps/positionableEdge";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import AlertModal from "../../../../../componentes/alertModal";
import ContextMenu from "../../../../../componentes/easyMaps/contextMenu";
import FilterElements from "../../../../../componentes/easyMaps/filterElements";
import TitleBar from "../../../../../componentes/easyMaps/titleBar";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import RightBarEasyMaps from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import EnlaceSideBarEasyMaps from "../../../../../componentes/easyMaps/enlaceSidebarEasyMaps";
import CreationSliderBarEasyMaps from "../../../../../componentes/easyMaps/creationSidebarEasymaps";
import api from "../../../../../services/api";
import { useOutletContext, useParams } from "react-router-dom";
import MenuMaps from "../../../../../componentes/easyMaps/menuMaps";
import LayerBar from "../../../../../componentes/easyMaps/layerBar";
import { useMapa } from "../../../../../contexts/mapaContext";
import ModalHistoryItem from "../../../../../componentes/easyMaps/historyItemModal";

const nodeTypes = {
  element: ElementNode,
};
const edgeTypes = {
  positionableedge: PositionableEdge,
};
function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = structuredClone(value ?? []);
  }, [value]);

  return ref.current;
}

const ReactFlowMapas = (props) => {
  const {
    connectionsAnalog,
    setEdgeSelected,
    setElementsConnected,
    iconsElements,
    setOpenRightBar,
    focusNodeId,
    handleCreateElement,
    handleUpdateElement,
    handleDeleteElement,
    handleCreateLink,
    handleDeleteLink,
    handleUpdateLink,
    handleCancelLink,
    fullScreem,
    setFullScreem,
    title,
    setCoordenadasFlow = () => {},
    setIconsElements,
    edgeSelected,
    coordenadasFlow,
    openRightBar,
    setFocusNodeId,
    socketCliente,
    mapas,
    addMapInMaps,
    produtos,
    changeConnection,
    loadinButtonEnlace,
    onImportComplete,
  } = props;
  const {
    mapId,
    elements,
    connections,
    connectionsDataMap,
    elementSelected,
    setElementSelected,
    connectionSelected,
    setConnectionSelected,
    editMode,
    configElementDataMap,
    setEditMode,
    checkChanges,
    setCheckChanges,
    setSnackbar,
    updateDataElementSocket,
    configurationMap,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
    alertsDataMap,
  } = useMapa();

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const bounds = getNodesBounds(nodes.filter((node) => !!node?.id));
  const [lockMode, setLockMode] = useState(false);
  //const [fullScreem, setFullScreem] = useState(false);
  const [showLabel, setShowLabel] = useState(true);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  //const [menuCreation, setMenuCreation] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const [contextMenuFlow, setContextMenuFlow] = useState(null);
  const [elementsFilter, setElementsFilter] = useState([]);
  const [openConnection, setOpenConnection] = useState(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  const [openEnlaceBar, setOpenEnlaceBar] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [connectionLocal, setConnectionLocal] = useState(null);
  const [hostParamModal, setHostParamModal] = useState("");

  const previousHandlers = usePrevious(edgeSelected?.data?.positionHandlers);
  const previousConnection = usePrevious(edgeSelected?.id);
  // pega os elementos e conexões do Map
  const elementsFromMap = useMemo(() => [...elements?.values()], [elements]);
  const connectionsFromMap = useMemo(
    () => [...connections?.values()],
    [connections],
  );
  const ref = useRef();
  const creationRef = useRef();
  const enlaceBarRef = useRef();
  const { id } = useParams();
  const { configLayer } = useOutletContext();
  const theme = useTheme();
  const styles = {
    stackContainer: {
      position: fullScreem ? "fixed" : "relative",
      top: 0,
      left: 0,
      width: fullScreem ? "100vw" : "100%",
      height: fullScreem ? "100vh" : "100%",
      zIndex: fullScreem ? 1202 : 0,
      background:
        theme.palette.mode == "dark"
          ? theme.palette.background.default
          : lighten(theme.palette.background.default, 0.6),
      overflow: "visible",
    },
  };
  const filteredData = useMemo(() => {
    if (!configurationMap || !configLayer || editMode) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }
    const isPotencia = configLayer?.[mapId] === "potencia";
    const filtros =
      configurationMap?.configuracoes?.[
        isPotencia ? "camadaPotencia" : "camadaTrafego"
      ]?.filtros;
    if (!filtros || filtros.length === 0) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }

    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    // Gera um Set com todos os IDs de conexões filtradas (evita includes O(n))
    const enlacesSelected = new Set(
      filtros?.flatMap((label) => dataMap.get(label) || []),
    );
    //filtras as conexões com base nos filtros
    const enlacesFiltered = connectionsFromMap.filter((conn) =>
      enlacesSelected.has(conn.id),
    );

    // Filtra conexões relevantes e extrai IDs únicos de markers
    const markersSelectedId = new Set(
      connectionsFromMap?.flatMap((conn) =>
        enlacesSelected.has(conn.id)
          ? [conn.destinationId, conn.referenceId]
          : [],
      ),
    );
    // Retorna apenas markers com ID presente
    const filtered = elementsFromMap.filter((m) => markersSelectedId.has(m.id));

    return { nodes: filtered, edges: enlacesFiltered };
  }, [
    configurationMap,
    configLayer,
    mapId,
    elementsFromMap,
    connectionsFromMap,
    editMode,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
  ]);

  useEffect(() => {
    setCoordenadasFlow({
      x: bounds.x + bounds.width / 2,
      y: bounds.y + bounds.height / 2,
    });
  }, [nodes]);

  useEffect(() => {
    setContextMenu(null);
    setContextMenuFlow(null);
    setElementSelected(null);
    setConnectionSelected(null);
    //setOpenConnection(null);
    setElementsConnected(null);
    setNodes(
      handleFormaterNodes(
        structuredClone(filteredData?.nodes),
        editMode,
        showLabel,
      ),
    );
    setEdges(
      handleFormaterEdges(
        structuredClone(filteredData?.edges),
        editMode,
        showLabel,
      ),
    );
  }, [
    configLayer,
    editMode,
    showLabel,
    showLabelEnlace,
    elementsFilter,
    configurationMap,
    filteredData,
  ]);

  function handleReload() {
    setNodes(
      handleFormaterNodes(
        structuredClone(filteredData?.nodes),
        editMode,
        showLabel,
      ),
    );
    setEdges(
      handleFormaterEdges(
        structuredClone(filteredData?.edges),
        editMode,
        showLabel,
      ),
    );
  }

  useEffect(() => {
    if (!filteredData?.nodes && !filteredData?.edges) return;

    let formaterElements = structuredClone(filteredData?.nodes);
    if (elementSelected) {
      formaterElements = [
        ...filteredData?.nodes.filter((ele) => ele?.id !== elementSelected?.id),
        elementSelected,
      ];
    }
    let formaterConnections = structuredClone(filteredData?.edges);
    if (connectionSelected) {
      formaterConnections = [
        ...filteredData?.edges.filter(
          (conn) => conn?.id !== connectionSelected?.id,
        ),
        {
          ...connectionSelected,
          positionHandlers: edgeSelected?.data?.positionHandlers,
        },
      ];
    }
    setNodes(handleFormaterNodes(formaterElements, editMode, showLabel));
    setEdges(handleFormaterEdges(formaterConnections, editMode, showLabel));
  }, [filteredData, filteredData?.edges, connectionsDataMap]);

  // transformar em useCallback, caso queira.
  function updateElements() {
    if (!elementSelected) {
      // setNodes(handleFormaterNodes(filteredData?.nodes, editMode, showLabel));
    } else {
      let formaterElements = filteredData?.nodes;
      formaterElements = [
        ...filteredData?.nodes.filter((ele) => ele?.id !== elementSelected?.id),
        elementSelected,
      ];
      setNodes(handleFormaterNodes(formaterElements, editMode, showLabel));
    }
  }

  function updateConnection() {
    if (!connectionSelected) {
      return;
      //setEdges(handleFormaterEdges(filteredData?.edges, editMode, showLabel));
    } else {
      let formaterConnections = filteredData?.edges;
      formaterConnections = [
        ...filteredData?.edges.filter(
          (conn) => conn?.id !== connectionSelected?.id,
        ),
        {
          ...connectionSelected,
          positionHandlers: edgeSelected?.data?.positionHandlers,
        },
      ];
      setEdges(handleFormaterEdges(formaterConnections, editMode, showLabel));
    }
  }
  useEffect(() => {
    updateElements();
  }, [elementSelected]);

  useEffect(() => {
    updateConnection();
  }, [connectionSelected]);

  useEffect(() => {
    if (!connectionSelected) {
      setEdges(handleFormaterEdges(filteredData?.edges, editMode, showLabel));
    } else {
      let formaterConnections = filteredData?.edges;
      formaterConnections = [
        ...filteredData?.edges.filter(
          (conn) => conn?.id !== connectionSelected?.id,
        ),
        {
          ...connectionSelected,
          positionHandlers: edgeSelected?.data?.positionHandlers,
        },
      ];
      setEdges(handleFormaterEdges(formaterConnections, editMode, showLabel));
    }
  }, [connectionSelected]);
  //-----funcoes para formatação de dados

  const handleFormaterNodes = (
    elements,
    editMode = false,
    showLabel = true,
    entangled = true,
    selected = false,
  ) => {
    const filter = elementsFilter.map((value) => value.tipo);
    const newElements =
      elementsFilter.length > 0
        ? elements.filter(({ tipo }) => filter.includes(tipo))
        : elements;

    const result = newElements.map(
      ({ id, elementConfig, titulo, alerts, img, tipo }) => {
        return {
          id,
          type: "element",
          draggable: elementSelected && elementSelected?.id == id && editMode,
          position: {
            x: parseFloat(elementConfig?.config?.coordenadas?.long),
            y: parseFloat(elementConfig?.config?.coordenadas?.lat),
          },
          selected: elementSelected?.id === id ? true : false,
          data: {
            configElement: configElementDataMap.get(id),
            img:
              iconsElements?.find((icon) => icon.id == img)?.img ||
              iconsElements?.find(
                (icon) =>
                  icon.nome ==
                  (tipo === 0 ? "_roteador" : tipo === 1 ? "_mapa" : "_pop"),
              )?.img,

            editMode,
            showLabel,
            entangled,
            title: titulo,
            hosts: elementConfig?.config?.hosts,
            tipoMapa: 1,
            alerts: editMode ? [] : alertsDataMap.get(id) || [],
            easyMapsConfig: structuredClone(configurationMap),
            value: 123,
          },
        };
      },
    );
    return result;
  };
  const handleFormaterEdges = (
    conections,
    editMode = false,
    showLabel = true,
    entangled = true,
  ) => {
    const result = conections.map(
      ({ id, referenceId, destinationId, positionHandlers, config, data }) => {
        const dataConn = structuredClone(connectionsDataMap.get(id));
        return {
          id,
          source: referenceId,
          type: "positionableedge",
          animation: true,
          sourceHandle: config?.sourceHandle,
          targetHandle: config?.targetHandle,
          target: destinationId,
          animated:
            !editMode &&
            config?.animation !== "desativada" &&
            !dataConn?.isDown,
          updatable: "target",
          markerEnd: editMode
            ? {
                type: MarkerType.ArrowClosed,
                color: "#5e5e5e",
              }
            : "",
          labelStyle: { fill: "#26721f", fontWeight: 700 },
          selected: connectionSelected?.id === id ? true : false,
          data: {
            ...dataConn,
            host: elements?.get(referenceId)?.titulo,
            mapId: mapId,
            itensData: data,
            editMode,
            showLabel,
            variant: configLayer?.[mapId] || "trafego",
            showLabelEnlace,
            entangled,
            lineType: config?.type,
            capacidade: config?.capacidade,
            positionHandlers: structuredClone(positionHandlers ?? []),
            //perigo eminente, sob hipótese nenhuma mexa nessa linha de código!
            label: "999.99Mbps",
            animation: config?.animation,
            easyMapsConfig: structuredClone(configurationMap),
            configLine: config,
          },
        };
      },
    );
    return result;
  };
  //----funcoes do menu
  const onNodeContextMenu = useCallback(
    (event, node) => {
      event.preventDefault();
      if (editMode) {
        setContextMenu(
          contextMenu === null
            ? {
                id: node.id,
                top: event.clientY - 6,
                left: event.clientX + 2,
              }
            : null,
        );
      }
    },
    [setContextMenu, editMode],
  );

  //-----react flow
  const onContextMenu = useCallback(
    (event) => {
      event.preventDefault();
      setContextMenuFlow(
        contextMenu === null
          ? {
              mouseX: event.clientX + 2,
              mouseY: event.clientY - 6,
            }
          : null,
      );
    },
    [setContextMenuFlow, editMode],
  );

  // const updateMemberStatus = (elements, ids, updateData) => {
  //   return elements.map((element) => ({
  //     ...element,
  //     data: {
  //       ...element.data,
  //       ...updateData(ids.includes(element.id)),
  //     },
  //   }));
  // };
  const proceedUpdateMode = () => {
    if (elementSelected) {
      creationRef?.current?.update();
    }
    if (connectionSelected) {
      enlaceBarRef?.current?.update();
    }
    setEditMode(!editMode);
    setFullScreem(false);
  };

  const proceedUpdateElement = useCallback(
    (id) => {
      const selected = structuredClone(elements?.get(id));
      if (selected?.id === elementSelected?.id) {
        setElementSelected(null);
        return;
      }
      setConnectionSelected(null);
      setConnectionLocal(null);
      setOpenConnection(null);
      setEdgeSelected(null);
      setElementSelected(selected);

      updateConnection();
    },
    [elementSelected, elements, connectionSelected],
  );

  const saveUpdateCallback = () => {
    if (elementSelected && elementSelected?.id) {
      creationRef?.current?.update();
    } else {
      creationRef?.current?.create();
    }
    if (connectionSelected) {
      enlaceBarRef?.current?.update();
    }
  };
  const cancelUpdateElement = useCallback(() => {
    setElementSelected({ ...elementSelected });
    setConnectionSelected(null);
    setEdgeSelected(null);
    updateElements();
    updateConnection();
  }, [elementSelected]);

  const proceedUpdateConnection = useCallback(
    (id) => {
      const conn = connections?.get(id);
      let edge = edges.find((edge) => id === edge.id);

      setEdgeSelected(edge);

      if (!editMode) {
        setOpenConnection(id);
        setElementSelected(structuredClone(elements?.get(conn?.referenceId)));
        setEdges((edg) =>
          edg.map(({ data, ...rest }) => ({
            ...rest,
            data: { ...data, entangled: true },
          })),
        );
      } else {
        setElementSelected(null);
      }
      setConnectionSelected({
        ...conn,
        positionHandlers: edge?.data?.positionHandlers,
      });
      setConnectionLocal({
        ...conn,
        positionHandlers: edge?.data?.positionHandlers,
      });
      updateElements();
    },
    [connectionSelected, elementSelected, edges, connections, elements],
  );

  const cancelUpdateConnection = useCallback(() => {
    setConnectionSelected({
      ...connectionSelected,
      positionHandlers: edgeSelected?.data?.positionHandlers,
    });

    setEdgeSelected({ ...edgeSelected });
    setElementSelected(null);
    updateElements();
    updateConnection();
  }, [connectionSelected, edgeSelected]);

  const onNodeClick = (event, node) => {
    //verificações de modificação
    if (editMode && checkChanges) {
      if (connectionSelected && !elementSelected) {
        setOpenAlertModal({
          id: node.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja Salvá-las?",
          callback: (id) => {
            enlaceBarRef?.current?.update();
            proceedUpdateElement(id);
          },
          callbackCancel: cancelUpdateConnection,
        });
        return;
      }
      if (
        elementSelected?.id !== node?.id &&
        elementSelected &&
        !connectionSelected
      ) {
        setOpenAlertModal({
          id: node.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja Salvá-las?",
          callback: (id) => {
            creationRef?.current?.update();
            proceedUpdateElement(id);
          },
          callbackCancel: cancelUpdateElement,
        });
        return;
      }
      return;
    }
    // Lógica normal
    proceedUpdateElement(node.id);
  };

  const onEdgeClick = (event, edge) => {
    if (editMode && checkChanges) {
      if (
        connectionSelected?.id !== edge?.id &&
        connectionSelected &&
        !elementSelected
      ) {
        setOpenAlertModal({
          id: edge.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja salvar?",
          callback: (id) => {
            enlaceBarRef?.current?.update();
            proceedUpdateConnection(id);
          },
          callbackCancel: cancelUpdateConnection,
        });
        return;
      }
      if (elementSelected && !connectionSelected) {
        setOpenAlertModal({
          id: edge.id,
          open: true,
          severity: "info",
          buttonText: "Salvar",
          buttonCancelText: "Voltar",
          text: "As alterações feitas não foram salvas. Deseja salvar?",

          callback: (id) => {
            creationRef?.current?.update();
            proceedUpdateConnection(id);
          },
          callbackCancel: cancelUpdateElement,
        });
        return;
      }
    }

    if (connectionSelected?.id !== edge?.id) proceedUpdateConnection(edge.id);
    else {
      const conn = edges?.find((edge) => edge.id === edgeSelected?.id);
      setEdgeSelected(conn);
      setConnectionLocal(conn);
    }
  };
  const onEdgeUpdate = (oldEdge, newConnection) => {
    setCheckChanges(true);
    if (newConnection.source === newConnection.target) {
      return false;
    }
    let selected = connections?.get(oldEdge.id);
    setConnectionSelected({
      ...selected,
      config: {
        ...selected.config,
        sourceHandle: newConnection.sourceHandle,
        targetHandle: newConnection.targetHandle,
      },
      destinationId: newConnection.target,
      referenceId: newConnection.source,
    });

    setEdges((els) => updateEdge(oldEdge, newConnection, els));
    setEdgeSelected((edge) => {
      return { ...edge, ...newConnection };
    });
  };

  const onConnect = useCallback(
    (params) => {
      const id = Math.random();

      const formateParams = {
        id: id,
        type: "positionableedge",
        target: params.target,
        source: params.source,
        //animation: false,
        animated: false,
        sourceHandle: params.sourceHandle,
        targetHandle: params.targetHandle,
        markerEnd: editMode
          ? {
              type: MarkerType.ArrowClosed,
              color: "#5e5e5e",
            }
          : "",
        //labelStyle: { fill: "#26721f", fontWeight: 700 },
        data: {
          editMode: true,
          showLabel,
          entangled: true,
          lineType: "reta",
          positionHandlers: [],
          label: "999.99Mbps",
        },
      };
      const referenceElem = elements?.get(params.source);
      let hostOriginId = null;
      if (referenceElem.tipo == 0) {
        hostOriginId = referenceElem?.elementConfig?.config?.hosts[0]?.hostid;
      }
      const acessoProdutoId = referenceElem?.elementConfig?.config?.produtoId;
      const newConnection = {
        id: id,
        destinationId: params.target,
        referenceId: params.source,
        positionHandlers: [],
        config: {
          type: "reta",
          sourceHandle: params.sourceHandle,
          targetHandle: params.targetHandle,
          capacidade: "0",
          animation: "desativada",
          hostOriginId,
        },
        item: [
          {
            acessoProdutoId,
            hostOriginId,
          },
        ],
      };
      setCheckChanges(true);
      setConnectionSelected(newConnection);

      setEdgeSelected(formateParams);
      setEdges((els) => addEdge(formateParams, els));
    },
    [setEdges, elements, connections, edges],
  );

  const onPaneClick = (e) => {
    setContextMenu(null);
    if (editMode) {
      if (edgeSelected && connectionSelected) {
        setEdgeSelected(structuredClone({ ...edgeSelected }));
        setConnectionSelected(structuredClone({ ...connectionSelected }));
        //cancelUpdateConnection();
      }
      if (elementSelected)
        setElementSelected(structuredClone({ ...elementSelected }));
    } else {
      setConnectionSelected(null);
      setOpenConnection(null);
      setEdgeSelected(null);
      setConnectionLocal(null);

      setNodes(
        handleFormaterNodes(
          structuredClone(filteredData?.nodes),
          editMode,
          showLabel,
          true,
          false,
        ),
      );
      setEdges(
        handleFormaterEdges(
          structuredClone(filteredData?.edges),
          editMode,
          showLabel,
          true,
          false,
        ),
      );
      setElementsConnected(null);
    }
  };

  const onNodeDragStop = (event, node) => {
    if (elementSelected && elementSelected?.id === node?.id) {
      if (
        elementSelected?.elementConfig?.config?.coordenadas?.long !==
          node?.position?.x ||
        elementSelected?.elementConfig?.config?.coordenadas?.lat !==
          node?.position?.y
      ) {
        setElementSelected((ele) => ({
          ...ele,
          elementConfig: {
            config: {
              ...ele?.elementConfig?.config,
              coordenadas: { long: node?.position?.x, lat: node?.position?.y },
            },
          },
        }));
        setCheckChanges(true);
      }
    }
  };

  useEffect(() => {
    if (checkChanges || !editMode) return;

    if (
      (Array.isArray(previousConnection) && previousConnection.length == 0) ||
      !previousConnection ||
      previousConnection != edgeSelected?.id
    )
      return;

    if (
      JSON.stringify(previousHandlers) ==
      JSON.stringify(edgeSelected?.data?.positionHandlers)
    )
      return;

    setCheckChanges(true);
  }, [
    edges,
    edgeSelected?.data?.positionHandlers,
    edgeSelected?.data?.positionHandlers?.length,
  ]);

  const onEdgesDelete = (edge) => {
    if (editMode) handleDeleteLink(edge[0]?.id);
  };
  const onNodesDelete = (nodes) => {
    if (editMode) handleDeleteElement(nodes[0]?.id);
  };

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1203 }}>
        <TitleBar
          title={title}
          id={mapId}
          setSnackbar={setSnackbar}
          center={elementSelected != null || connectionSelected != null}
          exportImport={true}
          produtos={produtos}
          onImportComplete={onImportComplete}
        />
      </Box>
      <Stack sx={styles.stackContainer}>
        <ReactFlowProvider>
          <ToolBarMaps
            editMode={editMode}
            proceedUpdateMode={proceedUpdateMode}
            setEditMode={setEditMode}
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            lockMode={lockMode}
            setLockMode={setLockMode}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            setOpenAlertModal={setOpenAlertModal}
            checkChanges={checkChanges}
            tipo={1}
          >
            <ToolBarMaps.InputZoomTop />
          </ToolBarMaps>
          <LayerBar
            elementSelected={elementSelected}
            mapId={mapId}
            editMode={editMode}
          />
          {!editMode && (
            <DescriptionBar
              elementSelected={!!elementSelected}
              key={"descrptionbar"}
              variant="default"
              layer={configLayer?.[mapId] || "trafego"}
            />
          )}
          <FilterElements
            iconsElement={iconsElements}
            elementsFilter={elementsFilter}
            setElementsFilter={setElementsFilter}
            editMode={editMode}
          />
          <ZoomFlow
            id={id}
            focusNodeId={focusNodeId}
            setFocusNodeId={setFocusNodeId}
          />
          <ReactFlow
            ref={ref}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            snapToGrid={false}
            onEdgeUpdate={onEdgeUpdate}
            onConnect={onConnect}
            onPaneClick={onPaneClick}
            onContextMenu={onContextMenu}
            onNodeContextMenu={onNodeContextMenu}
            elementsSelectable={!lockMode}
            nodesConnectable={!lockMode && editMode}
            nodesDraggable={elementSelected != null && !lockMode && editMode}
            attributionPosition="bottom-left"
            fitView
            connectionMode={ConnectionMode.Loose}
            onNodeClick={onNodeClick}
            //onNodeDrag={onNodeDrag}
            onNodeDragStop={onNodeDragStop}
            onEdgeContextMenu={(e) => {
              setEdgeSelected(
                edges?.find((edge) => edge.id === edgeSelected?.id),
              );
            }}
            onEdgeClick={onEdgeClick}
            onEdgesDelete={onEdgesDelete}
            onNodesDelete={onNodesDelete}
            minZoom={0.5}
            maxZoom={3}
            proOptions={{ hideAttribution: true }}
          >
            <Background />
            {contextMenu && editMode && !connectionSelected && (
              <NodeMenu
                open={contextMenu !== null}
                onClose={onPaneClick}
                handleDelete={handleDeleteElement}
                handleCreate={handleCreateElement}
                {...contextMenu}
              />
            )}
          </ReactFlow>{" "}
          {editMode && (
            <MenuMaps
              setElementSelected={setElementSelected}
              iconsElement={iconsElements.filter((icon) =>
                icon?.nome?.startsWith("_"),
              )}
              setConnectionSelected={setConnectionSelected}
              checkChanges={checkChanges}
              setOpenAlertModal={setOpenAlertModal}
              saveUpdateCallback={saveUpdateCallback}
              openEnlaceBar={openEnlaceBar}
              setOpenEnlaceBar={setOpenEnlaceBar}
            />
          )}
          <RightBarEasyMaps
            mapId={mapId}
            setFocusNodeId={setFocusNodeId}
            open={openRightBar}
            setOpen={setOpenRightBar}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={!editMode && elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/${
              elementSelected?.mapRef?.tipo === 0 ? "geo" : "top"
            }/${elementSelected?.mapRefId ?? ""}`}
            setOpenHistoryModal={setOpenHistoryModal}
            connectionSelectedLocal={connectionLocal}
            setConnectionLocal={setConnectionLocal}
            setHostParamModal={setHostParamModal}
          />
          <CreationSliderBarEasyMaps
            editMode={editMode}
            handleReload={handleReload}
            fullScreem={fullScreem}
            ref={creationRef}
            setOpenAlertModal={setOpenAlertModal}
            updateDataElementSocket={updateDataElementSocket}
            checkChanges={checkChanges}
            setCheckChanges={setCheckChanges}
            iconsElement={iconsElements}
            setIconsElement={setIconsElements}
            socket={socketCliente}
            element={editMode ? elementSelected : null}
            produtos={produtos}
            api={api}
            maps={mapas}
            addMapInMaps={addMapInMaps}
            tipoMapa={1}
            coordenadasFlow={coordenadasFlow}
            setFocusNodeId={setFocusNodeId}
            deleteElementSocket={(id) =>
              setOpenAlertModal({
                open: true,
                id: id,
                severity: "error",
                tipo: "element",
              })
            }
            changeConnection={changeConnection}
            openEnlaceBar={openEnlaceBar}
            setOpenEnlaceBar={setOpenEnlaceBar}
          />
          {edgeSelected && (
            <EnlaceSideBarEasyMaps
              handleReload={handleReload}
              ref={enlaceBarRef}
              setOpenAlertModal={setOpenAlertModal}
              setEdgeSelected={setEdgeSelected}
              connection={editMode ? connectionSelected : null}
              setConnection={setConnectionSelected}
              edgeSelected={edgeSelected}
              api={api}
              produtos={produtos}
              iconsElement={iconsElements}
              elements={elements}
              saveConnection={
                isNaN(connectionSelected?.id)
                  ? handleUpdateLink
                  : handleCreateLink
              }
              handleCancel={handleCancelLink}
              //handleDelete={handleDeleteLink}
              changeConnection={changeConnection}
              fullScreem={fullScreem}
              tipoMapa={1}
              loadingButton={loadinButtonEnlace}
              handleDelete={(id) =>
                setOpenAlertModal({
                  open: true,
                  id: id,
                  severity: "error",
                  tipo: "enlace",
                })
              }
            />
          )}
        </ReactFlowProvider>{" "}
        <ContextMenu
          contextMenu={contextMenuFlow}
          setContextMenu={setContextMenuFlow}
          editMode={editMode}
          setEditMode={setEditMode}
        />
        <ModalHistoryItem
          openHistoryModal={openHistoryModal}
          setOpenHistoryModal={setOpenHistoryModal}
          elementSelected={elementSelected}
          enlaceSelected={connectionLocal}
          iconsElements={iconsElements}
          host={hostParamModal}
        />
        <AlertModal
          openModal={openAlertModal?.open ?? false}
          setOpenModal={(data) => setOpenAlertModal({ open: data })}
          buttonText={openAlertModal?.buttonText}
          buttonCancelText={openAlertModal?.buttonCancelText}
          confirmar={false}
          handleButton={() => {
            setCheckChanges(false);
            setOpenAlertModal({ open: false });
            if (openAlertModal.callback) {
              openAlertModal.callback(openAlertModal?.id);
              return;
            } else {
              setElementSelected(null);
              setConnectionSelected(null);
              setEdgeSelected(null);
            }
            if (openAlertModal?.severity == "error") {
              if (openAlertModal.tipo == "enlace")
                handleDeleteLink(openAlertModal?.id);
              if (openAlertModal.tipo == "element")
                handleDeleteElement(openAlertModal?.id);
              return;
            }
          }}
          handleCancel={() => {
            if (openAlertModal?.callbackCancel) {
              openAlertModal.callbackCancel();
              return;
            }
            setOpenAlertModal({ open: false });
          }}
          severity={openAlertModal?.severity}
          singleButton={false}
          textContent={openAlertModal?.text}
        />
      </Stack>{" "}
    </>
  );
};
export default ReactFlowMapas;
